export default __webpack_public_path__ + "static/media/img-0149-india-full-face.2a04319f.png";